/** Modulo Cardapio (160) — codigos em contracts/enums.yaml. Nao existe 1603. */
export const CARDAPIO_ACAO = {
  ATUALIZAR: 1601,
  REMOVER: 1602,
} as const;

export const CARDAPIO_ACOES_MODULO = [CARDAPIO_ACAO.ATUALIZAR, CARDAPIO_ACAO.REMOVER] as const;
